import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const RugbyColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g id="Rugby" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M9.002 8.94C4.041 13.9 3.936 21.394 2.46 19.923c-.643-.64-1.015-1.458-1.03-2.653C1.391 14.094 2.493 9.704 6.1 6.1c4.94-4.94 11.325-4.646 14.255-3.516C21.944 3.197 13.942 4 9.002 8.94z"
                    fill="#FF4054"
                />
                <path
                    d="M14.736 14.65C19.697 9.686 20.856 2.247 22 3.966c1 1.502 0 8.767-4.361 13.523-4.361 4.755-10.8 4.646-13.73 3.516-1.59-.614 5.887-1.418 10.827-6.357z"
                    fill="#FF4054"
                />
                <path
                    d="M16.668 16.668c-4.095 4.095-8.509 4.577-11.489 4.257a2.362 2.362 0 0 1-.439-.093c.014 0 .027.003.041.003 1.045 0 2.316-.494 3.364-1.014 2.186-1.085 4.58-2.871 6.738-5.03 3.734-3.735 5.862-7.716 6.001-9.81.016.079.036.154.045.234.309 2.972-.179 7.37-4.26 11.453M7.331 7.332c3.458-3.458 7.145-4.337 9.997-4.337.112 0 .207.014.316.016-2.802.515-6.7 2.824-9.199 5.323-2.032 2.032-4.7 5.993-5.447 8.937.01-2.85.899-6.505 4.333-9.939m11.575-2.446c-.038 1.04-1.52 4.572-5.439 8.49-4.09 4.09-7.708 5.504-8.699 5.469-.236-1.147 1.848-5.852 5.092-9.097 3.163-3.164 7.753-5.076 9.046-4.862m.085-3.805C16.204.793 10.8 1.035 5.918 5.917c-4.9 4.9-5.13 10.32-4.832 13.117a4.391 4.391 0 0 0 3.88 3.88c.474.05 1.025.087 1.635.087 2.985 0 7.414-.85 11.482-4.919 4.883-4.884 5.126-10.288 4.835-13.074a4.426 4.426 0 0 0-3.926-3.927z"
                    fill="#0D0E0F"
                />
            </g>
        </svg>
    );
};
